import * as React from 'react';
import { useAccountTwrrPTAccTwrrPSumIn, useAccountTwrrCCurrencyCode } from '../../hooks';
import { ActorApiNumberDisplayCurrency } from '../../../../../../components/display/number/currency';

export const AccountsTwrrTAccTwrrSumIn = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountTwrrPTAccTwrrPSumIn();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = useAccountTwrrCCurrencyCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};
